/* =========================================================
   SOUTH MINI SPLITS / CUSTOM.JS
   First code + newer wishlist logic
   ========================================================= */

/* =========================================================
   MAIN SITE JS
   ========================================================= */
$(document).ready(function () {
  // Review Slider
  if ($('.cstm_review_slider').length) {
    $('.cstm_review_slider').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:
        '<div class="swiper_buttons slick_left_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="#040404" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
      nextArrow:
        '<div class="swiper_buttons slick_right_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="#040404" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  // Multi Image with Text js
  if (typeof Swiper !== 'undefined' && document.querySelector('.multicolumm_imagetext_main')) {
    new Swiper('.multicolumm_imagetext_main', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      slidesPerView: 'auto',
      paginationClickable: true,
      spaceBetween: 0
    });
  }

  // Tab Collection Slider
  function initCollectionTabSliders() {
    if (!$('.collectiontab_slider').length || typeof $.fn.slick !== 'function') return;

    $('.collectiontab_slider').each(function () {
      var $slider = $(this);

      if ($slider.hasClass('slick-initialized')) return;

      $slider.slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        prevArrow:
          '<div class="swiper_buttons slick_left_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="#040404" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
        nextArrow:
          '<div class="swiper_buttons slick_right_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="#040404" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 989,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      });
    });
  }

  initCollectionTabSliders();

  $('li.tab_collection').on('click', function () {
    $('.collectiontab_slider').each(function () {
      var $slider = $(this);
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }
    });
  });

  // Collection tab js
  var firstTab = document.querySelector('ul .tab_collection');
  if (firstTab) {
    var fstCollection = firstTab.getAttribute('data');
    firstTab.classList.add('active');

    document.querySelectorAll('.collectiontab_slider').forEach(function (df) {
      if (df.getAttribute('slide-data') === fstCollection) {
        df.classList.add('active');
      }
    });

    document.querySelectorAll('.tab_collection').forEach(function (element) {
      element.addEventListener('click', function () {
        document.querySelectorAll('.tab_collection').forEach(function (el) {
          el.classList.remove('active');
        });

        this.classList.add('active');

        var crntData = element.getAttribute('data');
        document.querySelectorAll('.collectiontab_slider').forEach(function (has) {
          var slideData = has.getAttribute('slide-data');
          if (slideData === crntData) {
            has.classList.add('active');
            if ($(has).hasClass('slick-initialized')) {
              $(has).slick('setPosition');
            }
          } else {
            has.classList.remove('active');
          }
        });
      });
    });
  }

  // Mobile collage slider
  if ($(window).width() < 767 && $('.collage_grid_collblog').length) {
    $('.collage_grid_collblog').slick({
      infinite: false,
      slidesToShow: 1,
      arrows: false,
      adaptiveHeight: true,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
});

/* =========================================================
   PRODUCT DESCRIPTION TAB
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.description_data_tabs');
  const tabContents = document.querySelectorAll('.cstm_description_tab_content');

  if (tabButtons.length > 0 && tabContents.length > 0) {
    tabButtons[0].classList.add('active_data');
    tabContents[0].classList.add('active_data');
  }

  tabButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      const tabId = this.getAttribute('data-tab');

      tabButtons.forEach(function (btn) {
        btn.classList.remove('active_data');
      });

      tabContents.forEach(function (content) {
        content.classList.remove('active_data');
      });

      this.classList.add('active_data');

      const target = document.querySelector('.cstm_description_tab_content[data-id="' + tabId + '"]');
      if (target) {
        target.classList.add('active_data');
      }
    });
  });
});

/* =========================================================
   ACCESSORIES CHECKOUT POPUP LOGIC
   ========================================================= */
$(document).ready(function () {
  var popup = document.getElementById('addons_accessoriescart_popup');
  if (!popup) return;

  var allowCheckoutSubmit = false;
  var pendingCheckoutFormId = null;

  function showAccessoriesPopup() {
    popup.style.display = 'block';
  }

  function closeAccessoriesPopup() {
    popup.style.display = 'none';
  }

  function getPolicyInput(formId) {
    var inputName = 'input[name="attributes[policy_acknowledgement]"][required]';
    var policyInput = null;

    if (formId) {
      policyInput = document.querySelector(inputName + '[form="' + formId + '"]');
      if (policyInput) return policyInput;

      var formEl = document.getElementById(formId);
      if (formEl) {
        policyInput = formEl.querySelector(inputName);
        if (policyInput) return policyInput;
      }
    }

    var allInputs = Array.prototype.slice.call(document.querySelectorAll(inputName));
    if (!allInputs.length) return null;

    var visibleInput = allInputs.find(function (input) {
      return input.offsetParent !== null;
    });

    return visibleInput || allInputs[0];
  }

  function isPolicyAcknowledged(formId) {
    var policyInput = getPolicyInput(formId || pendingCheckoutFormId);
    if (!policyInput) return true;
    if (policyInput.checked) return true;
    if (typeof policyInput.reportValidity === 'function') {
      policyInput.reportValidity();
    }
    return false;
  }

  // Intercept checkout button clicks first so cart form cannot auto-submit.
  document.addEventListener('click', function (event) {
    var checkoutBtn = event.target.closest('button[name="checkout"]');
    if (!checkoutBtn) return;
    if (allowCheckoutSubmit) return;

    pendingCheckoutFormId =
      checkoutBtn.getAttribute('form') ||
      (checkoutBtn.form && checkoutBtn.form.id) ||
      null;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (!isPolicyAcknowledged(pendingCheckoutFormId)) return;
    showAccessoriesPopup();
  }, true);

  // Safety net: block checkout form submit unless user approved via popup CTA.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart"]')) return;

    var submitter = event.submitter;
    var isCheckoutSubmit = submitter && submitter.name === 'checkout';

    if (isCheckoutSubmit && !allowCheckoutSubmit) {
      pendingCheckoutFormId =
        submitter.getAttribute('form') ||
        (submitter.form && submitter.form.id) ||
        (form && form.id) ||
        null;

      event.preventDefault();
      event.stopPropagation();

      if (!isPolicyAcknowledged(pendingCheckoutFormId)) return;
      showAccessoriesPopup();
    }
  }, true);

  // Closing the accessories popup should continue checkout.
  $(document).on('click', '.close_addonpopup_cart, .addons_product_popup_background', function (event) {
    event.preventDefault();

    if (!isPolicyAcknowledged(pendingCheckoutFormId)) {
      closeAccessoriesPopup();
      return;
    }

    allowCheckoutSubmit = true;
    closeAccessoriesPopup();
    window.location.href = '/checkout';
  });

  // Popup checkout CTA: allow checkout flow and continue.
  $(document).on('click', '.addons_checkout_redirection a', function (event) {
    if (!isPolicyAcknowledged(pendingCheckoutFormId)) {
      event.preventDefault();
      return;
    }
    allowCheckoutSubmit = true;
  });
});

function hidePopup() {
  var popup = document.getElementById('addons_accessoriescart_popup');
  if (popup) popup.style.display = 'none';
}

/* =========================================================
   PRODUCT SWATCH JS
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  const radioButtons = document.querySelectorAll('.product-form__input--pill input[type="radio"]');
  radioButtons.forEach(function (radio) {
    radio.removeAttribute('checked');
  });
});

/* =========================================================
   PRODUCT FORM / FAQ ACCORDION
   ========================================================= */
$(document).ready(function () {
  $('.product_with_variants button.product-form__submit').on('click', function () {
    var checkedCount = $('.product-form__input--pill input[type="radio"]:checked').length;

    if (checkedCount === 0) {
      $('.product_error_message').show();
      return false;
    } else {
      $('.product_error_message').hide();
    }
  });

  $('.product-form__input--pill input[type="radio"]').on('click', function () {
    var noInstallationChecked = $(this).hasClass('no_installation_variant');
    if (noInstallationChecked) {
      $('.product_error_message').show();
    } else {
      $('.product_error_message').hide();
    }
  });

  // FAQ Accordion Js
  $('.accordian_contains').hide();
  $('.accordion_in_flxs').click(function () {
    $('.accordion_in_icons').css('transform', 'rotate(0deg)');

    if ($('.accordian_contains').is(':visible')) {
      $('.accordian_contains').slideUp(300);
    }

    if ($(this).next('.accordian_contains').is(':visible')) {
      $(this).next('.accordian_contains').slideUp(300);
      $(this).closest('.accordion_inners').find('.accordion_in_icons').css('transform', 'rotate(0deg)');
    } else {
      $(this).next('.accordian_contains').slideDown(300);
      $(this).closest('.accordion_inners').find('.accordion_in_icons').css('transform', 'rotate(180deg)');
    }

    $('.accordion_in_flxs').removeClass('colored_text');
    $(this).addClass('colored_text');
  });
});

/* =========================================================
   MOBILE FILTER JS
   ========================================================= */
document.querySelectorAll('.ast_collection_cstm .mobile-facets__open-wrapper').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    document.querySelectorAll('.mobile_cstm_detail_filter').forEach(function (filter) {
      filter.setAttribute('open', '');
    });
  });
});

/* =========================================================
   NEW WISHLIST JS (REPLACES OLD WISHLIST BLOCK)
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  if (window.__smsWishlistInit) return;
  window.__smsWishlistInit = true;

  const STORAGE_KEY = 'smsWishlist';
  const popup = document.querySelector('footer .Popup') || document.querySelector('.Popup');
  const popupInner = popup ? popup.querySelector('.PopupInner') : null;
  const listContainer = popup ? popup.querySelector('.productdata-container') : null;
  const spinner = popup ? popup.querySelector('#LoadSpinner') : null;
  const headerWishlistBtn = document.querySelector('.header_whishlist_icon');
  const productCache = new Map();

  function isPopupOpen() {
    return !!popup && popup.style.display === 'block';
  }

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function setWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    syncWishlistIcons();
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeValue(str) {
    return String(str || '').trim().toLowerCase();
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
    }
    return '$' + ((cents || 0) / 100).toFixed(2);
  }

  function openPopup() {
    if (!popup) return;
    popup.style.display = 'block';
    document.body.classList.add('OverFlowHidden');

    requestAnimationFrame(function () {
      popup.style.opacity = '1';
      popup.style.visibility = 'visible';
    });
  }

  function closePopup() {
    if (!popup) return;
    popup.style.opacity = '0';
    popup.style.visibility = 'hidden';
    document.body.classList.remove('OverFlowHidden');

    setTimeout(function () {
      popup.style.display = 'none';
    }, 250);
  }

  function syncWishlistIcons() {
    const items = getWishlist();

    document.querySelectorAll('.cstm_whislist_icon.wishList[data-product-handle]').forEach(function (btn) {
      const handle = btn.getAttribute('data-product-handle');
      const active = items.includes(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (headerWishlistBtn) {
      headerWishlistBtn.classList.toggle('has-items', items.length > 0);
    }
  }

  async function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);

    const res = await fetch('/products/' + encodeURIComponent(handle) + '.js');
    if (!res.ok) throw new Error('Failed to fetch product: ' + handle);

    const product = await res.json();
    productCache.set(handle, product);
    return product;
  }

  function getDefaultVariant(product) {
    return (product.variants || []).find(function (v) {
      return v.available;
    }) || (product.variants || [])[0] || null;
  }

  function getDisplayOptionName(option) {
    const rawName = String(option.name || '').replace(/\s+/g, ' ').trim();
    const lowerName = normalizeValue(rawName);

    if (lowerName && lowerName !== 'title') {
      return rawName;
    }

    const values = option.values.map(function (value) {
      return normalizeValue(value);
    });

    if (values.some(function (v) { return v.includes('installation'); })) return 'Installation Kit';
    if (values.some(function (v) { return v.includes('line set'); })) return 'Line Set';
    if (values.some(function (v) { return v.includes('wire'); })) return 'Wire Option';
    if (values.some(function (v) { return v.includes('zone'); })) return 'Zone Option';
    if (values.some(function (v) { return v.includes('head'); })) return 'Head Option';

    return 'Options';
  }

  function getMeaningfulOptions(product) {
    const rawOptions = Array.isArray(product.options) ? product.options : [];
    const variants = Array.isArray(product.variants) ? product.variants : [];

    if (!rawOptions.length || !variants.length) return [];

    const mapped = rawOptions.map(function (entry, index) {
      const key = 'option' + (index + 1);
      const label = typeof entry === 'string'
        ? entry
        : (entry && typeof entry === 'object' && entry.name ? entry.name : 'Option');

      const values = [];
      variants.forEach(function (variant) {
        const value = variant[key];
        if (value != null && !values.includes(value)) values.push(value);
      });

      return {
        name: String(label || 'Option').replace(/\s+/g, ' ').trim(),
        displayName: '',
        index: index + 1,
        values: values
      };
    });

    if (
      mapped.length === 1 &&
      normalizeValue(mapped[0].name) === 'title' &&
      mapped[0].values.length === 1 &&
      normalizeValue(mapped[0].values[0]) === 'default title'
    ) {
      return [];
    }

    return mapped
      .filter(function (opt) {
        return opt.values.length > 1;
      })
      .map(function (opt) {
        opt.displayName = getDisplayOptionName(opt);
        return opt;
      });
  }

  function buildVariantSelectors(product) {
    const meaningfulOptions = getMeaningfulOptions(product);

    if (!meaningfulOptions.length) {
      return '<div class="wishlist-no-options">—</div>';
    }

    const defaultVariant = getDefaultVariant(product);

    return `
      <div class="wishlist-option-stack">
        ${meaningfulOptions.map(function (opt) {
          const selectedValue = defaultVariant ? defaultVariant['option' + opt.index] : '';
          return `
            <div class="wishlist-option-group">
              <label class="wishlist-option-label">${escapeHtml(opt.displayName)}</label>
              <select class="wishlist-option-select" data-option-index="${opt.index}">
                ${opt.values.map(function (value) {
                  const selected = value === selectedValue ? 'selected' : '';
                  return `<option value="${escapeHtml(value)}" ${selected}>${escapeHtml(value)}</option>`;
                }).join('')}
              </select>
            </div>
          `;
        }).join('')}
      </div>
    `;
  }

  function buildRow(product) {
    const defaultVariant = getDefaultVariant(product);
    const imageSrc =
      product.featured_image ||
      (product.images && product.images.length ? product.images[0] : '');

    const priceHtml = defaultVariant ? formatMoney(defaultVariant.price) : '';
    const cartIconMarkup = document.getElementById('PopupCartIcon')
      ? document.getElementById('PopupCartIcon').innerHTML
      : '🛒';

    return `
      <div class="product-row"
           data-product-handle="${escapeHtml(product.handle)}"
           data-selected-variant-id="${defaultVariant ? defaultVariant.id : ''}">
        <div class="product-img">
          <div class="product-img-inner">
            ${imageSrc ? `<img src="${escapeHtml(imageSrc)}" alt="${escapeHtml(product.title)}">` : ''}
          </div>
        </div>

        <div class="product-title">
          <h2>${escapeHtml(product.title)}</h2>
        </div>

        <div class="product-price">
          <p>${priceHtml}</p>
        </div>

        <div class="product-quantity">
          <div class="quantity">
            <button class="quantity__button" type="button" data-qty-minus>-</button>
            <input class="quantity__input" type="number" min="1" value="1">
            <button class="quantity__button" type="button" data-qty-plus>+</button>
          </div>
        </div>

        <div class="product-variant-options">
          ${buildVariantSelectors(product)}
        </div>

        <div class="product-action">
          <span class="DeleteFromList" data-product-handle="${escapeHtml(product.handle)}">×</span>
          <span class="AddCart" title="Add to cart">${cartIconMarkup}</span>
        </div>
      </div>
    `;
  }

  function getCurrentSelections(row) {
    const selections = {};
    row.querySelectorAll('.wishlist-option-select').forEach(function (select) {
      selections[select.dataset.optionIndex] = select.value;
    });
    return selections;
  }

  function updateRowVariant(row, variant) {
    if (!row || !variant) return;

    row.dataset.selectedVariantId = variant.id;

    const priceEl = row.querySelector('.product-price p');
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    }
  }

  function refreshRowSelectors(row, product) {
    const selects = Array.from(row.querySelectorAll('.wishlist-option-select'));

    if (!selects.length) {
      const defaultVariant = getDefaultVariant(product);
      if (defaultVariant) updateRowVariant(row, defaultVariant);
      return;
    }

    selects.forEach(function (select) {
      const optionIndex = String(select.dataset.optionIndex);
      const selections = getCurrentSelections(row);

      Array.from(select.options).forEach(function (optionEl) {
        const matches = (product.variants || []).filter(function (variant) {
          if (!variant.available) return false;
          if (variant['option' + optionIndex] !== optionEl.value) return false;

          return Object.keys(selections).every(function (key) {
            if (key === optionIndex) return true;
            return !selections[key] || variant['option' + key] === selections[key];
          });
        });

        optionEl.disabled = matches.length === 0;
      });

      const currentOption = select.options[select.selectedIndex];
      if (currentOption && currentOption.disabled) {
        const firstEnabled = Array.from(select.options).find(function (opt) {
          return !opt.disabled;
        });
        if (firstEnabled) select.value = firstEnabled.value;
      }
    });

    const selections = getCurrentSelections(row);
    let exactMatch = (product.variants || []).find(function (variant) {
      if (!variant.available) return false;

      return Object.keys(selections).every(function (key) {
        return variant['option' + key] === selections[key];
      });
    });

    if (!exactMatch) {
      exactMatch = getDefaultVariant(product);

      if (exactMatch) {
        selects.forEach(function (select) {
          const idx = select.dataset.optionIndex;
          const value = exactMatch['option' + idx];
          if (value) select.value = value;
        });
      }
    }

    if (exactMatch) {
      updateRowVariant(row, exactMatch);
    }
  }

  async function renderWishlist() {
    if (!listContainer) return;

    const items = getWishlist();
    listContainer.innerHTML = '';

    if (!items.length) {
      listContainer.innerHTML = `
        <div class="product-row">
          <div style="width:100%;padding:20px;text-align:center;border:1px solid #f1f1f1;border-radius:14px;background:#fff;">
            Your wishlist is empty.
          </div>
        </div>
      `;
      return;
    }

    if (spinner) spinner.style.display = 'block';

    try {
      const products = await Promise.all(
        items.map(async function (handle) {
          try {
            return await fetchProduct(handle);
          } catch (e) {
            return null;
          }
        })
      );

      const validProducts = products.filter(Boolean);
      listContainer.innerHTML = validProducts.map(buildRow).join('');

      validProducts.forEach(function (product) {
        const rows = Array.from(listContainer.querySelectorAll('.product-row'));
        const row = rows.find(function (el) {
          return el.getAttribute('data-product-handle') === product.handle;
        });
        if (row) refreshRowSelectors(row, product);
      });
    } finally {
      if (spinner) spinner.style.display = 'none';
    }
  }

  document.addEventListener('click', async function (event) {
    const heartBtn = event.target.closest('.cstm_whislist_icon.wishList[data-product-handle]');
    const headerBtn = event.target.closest('.header_whishlist_icon');

    if (heartBtn) {
      event.preventDefault();
      event.stopPropagation();

      const handle = heartBtn.getAttribute('data-product-handle');
      let items = getWishlist();

      if (items.includes(handle)) {
        items = items.filter(function (item) {
          return item !== handle;
        });
        setWishlist(items);

        if (isPopupOpen()) {
          await renderWishlist();
        }
      } else {
        items.push(handle);
        setWishlist(items);
        await renderWishlist();
        openPopup();
      }
      return;
    }

    if (headerBtn) {
      event.preventDefault();
      event.stopPropagation();
      await renderWishlist();
      openPopup();
      return;
    }
  });

  if (popup) {
    popup.addEventListener('click', function (event) {
      const closeBtn = event.target.closest('#ClosePopup');

      if (closeBtn) {
        event.preventDefault();
        event.stopPropagation();
        closePopup();
        return;
      }

      if (!event.target.closest('.PopupInner')) {
        closePopup();
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isPopupOpen()) {
      closePopup();
    }
  });

  if (listContainer) {
    listContainer.addEventListener('click', async function (event) {
      event.preventDefault();
      event.stopPropagation();

      const row = event.target.closest('.product-row');
      if (!row) return;

      const handle = row.getAttribute('data-product-handle');
      const product = handle ? productCache.get(handle) : null;
      const qtyInput = row.querySelector('.quantity__input');

      if (event.target.closest('[data-qty-minus]')) {
        const current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = Math.max(1, current - 1);
        return;
      }

      if (event.target.closest('[data-qty-plus]')) {
        const current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = current + 1;
        return;
      }

      if (event.target.closest('.DeleteFromList')) {
        const removeHandle = event.target.closest('.DeleteFromList').getAttribute('data-product-handle');
        const items = getWishlist().filter(function (item) {
          return item !== removeHandle;
        });
        setWishlist(items);
        await renderWishlist();

        if (!getWishlist().length) {
          openPopup();
        }

        return;
      }

      if (event.target.closest('.AddCart')) {
        const variantId = parseInt(row.dataset.selectedVariantId || '0', 10);
        const quantity = Math.max(1, parseInt(qtyInput.value || '1', 10));

        if (!variantId) {
          alert('Please select a variant.');
          return;
        }

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity
            })
          });

          if (!res.ok) throw new Error('Cart add failed');
          alert('Item added to cart.');
        } catch (err) {
          alert('Unable to add item to cart.');
        }
        return;
      }

      if (product) {
        refreshRowSelectors(row, product);
      }
    });

    listContainer.addEventListener('change', function (event) {
      event.stopPropagation();

      const select = event.target.closest('.wishlist-option-select');
      if (!select) return;

      const row = select.closest('.product-row');
      if (!row) return;

      const handle = row.getAttribute('data-product-handle');
      const product = handle ? productCache.get(handle) : null;
      if (!product) return;

      refreshRowSelectors(row, product);
    });
  }

  syncWishlistIcons();
});